import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Rota değişince pencereyi en üste kaydırır (SPA’da scroll konumunun taşınmasını önler).
 */
export function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);

    return null;
}
